<script>
import { required } from "vuelidate/lib/validators";
import Modal from "@/components/modals/modal-form.vue";
import api from '@/helpers/apirest/api';
import Status from "@/helpers/general/status";
import SelectAutocompleteField from "@/components/forms/select-autocomplete-field.vue";

const initialState = () => {
    return {
        submitted: false,
        card_application: {
            card_application_type_id: '',
            population: null,
            population_id: null,
            shipping_type: '',
            card_shipping_type: null,
            card_shipping_type_id: null,
            origin_shipping_type: '',
            origin_card_shipping_type: null,
            origin_card_shipping_type_id: null,
            observations: null,
            amount: 0,
            status: 'processing',
            exclude_payment: false
        },
        card_application_type: null
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        customerId: Number,
        cardApplicationTypeSlug: String
    },
    data() {
        return initialState();
    },
    components: {
        Modal,
        SelectAutocompleteField,
    },
    computed: {
        shippingTypes() {
            return Status.getList('shipping_types');
        },
        amount(){
            return (!this.card_application?.exclude_payment) ? this.card_application_type?.amount : 0;
        },
        title() {
            switch (this.cardApplicationTypeSlug) {
                case 'renewal':
                    return 'Renovación';
                case 'duplicate':
                    return 'Duplicado';
                case 'refund':
                    return 'Devolución';
                case 'loss':
                    return 'Perdida';
                case 'stolen':
                    return 'Robo';
                default:
                    return '';
            }
        }
    },
    validations: {
        card_application: {

            card_application_type_id: { required },
            shipping_type: { required },
            origin_shipping_type: { required },
            observations: {  },
            status: { required },
            card_shipping_type: { 
                required(value) {
                    return this.card_application.shipping_type !== 'online' ? !!value : true;
                }
            },
            origin_card_shipping_type: { 
                required(value) {
                    return this.card_application.origin_shipping_type !== 'online' ? !!value : true;
                }
            },
            // population: { 
            //     required(value) {
            //         return this.card_application.shipping_type !== 'online' ? !!value : true;
            //     }
            // },
        }
    },
    methods: {
        async shown() {
            const response = await api.get({
                url: `card-application-types/${this.cardApplicationTypeSlug}`,
                config: {
                    withLoading: true
                }  
            });

            this.card_application_type = response?.data?.data;
            this.card_application.card_application_type_id = this.card_application_type?.id;
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            const data = this.card_application;
            data.identification_media_id = this.card_application?.identification_media?.id;
            data.population_id = this.card_application?.population?.id;
            data.card_shipping_type_id = this.card_application?.card_shipping_type?.id;
            data.origin_card_shipping_type_id = this.card_application?.origin_card_shipping_type?.id;
            const response = await api.save({
                url: `customers/${this.customerId}/card-applications`,
                data: data,
                config: {
                    withLoading: true
                }
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess", response?.data?.data);
        },
        changeShippingType() {
            this.card_application.card_shipping_type_id = '';
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        },
    }
};
</script>

<template>
    <Modal :title="'Formulario de solicitud - ' + title" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal" :size="'lg'">
        <div class="card h-100">
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-12">
                        <label for="amount">Valor</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend" v-if="cardApplicationTypeSlug === 'duplicate'">
                                <div class="input-group-text">
                                    <label class="m-0 p-0" for="exclude_payment">Excluir pago</label> <input v-model="card_application.exclude_payment" id="exclude_payment" type="checkbox" class="ml-2">
                                </div>
                            </div>
                            <input type="text" id="amount" :value="amount" class="form-control" readonly>
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label for="observations">Motivo</label>
                        <textarea v-model="card_application.observations" class="form-control"
                            :class="{ 'is-invalid': $v.card_application.observations.$error && submitted }">
                        </textarea>
                    </div>
                    <div class="form-group col-12">
                        <label for="origin_shipping_type">Tipo de creación</label>
                        <select v-model="card_application.origin_shipping_type" class="form-control"
                            :class="{ 'is-invalid': $v.card_application.origin_shipping_type.$error && submitted }">
                            <option value="">Ninguno</option>
                            <option v-for="option in shippingTypes" v-bind:value="option.id" :key="option.id">
                                {{ option.description }}
                            </option>
                        </select>
                        <div v-if="!$v.card_application.origin_shipping_type.required && submitted" class="invalid-feedback">Tipo de creación es requerida</div>
                    </div>
                    <div class="form-group col-12" v-if="card_application.origin_shipping_type != '' && card_application.origin_shipping_type != 'online'">
                        <label>Oficina de creación</label>
                        <SelectAutocompleteField
                            :url="`/card-shipping-types`"
                            :multiple="false"
                            label="full_name"
                            :placeholder="'Busca una oficina'"
                            v-model="card_application.origin_card_shipping_type"
                            :params="{shipping_type: card_application.origin_shipping_type}"
                            :class="{ 'is-invalid': $v.card_application.origin_card_shipping_type.$error && submitted }"
                        ></SelectAutocompleteField>
                        <div v-if="!$v.card_application.origin_card_shipping_type.required && submitted" class="invalid-feedback">Oficina de creación es requerida</div>
                    </div>

                    <div class="form-group col-12">
                        <label for="shipping_type">Tipo de envío</label>
                        <select v-model="card_application.shipping_type" class="form-control"
                            :class="{ 'is-invalid': $v.card_application.shipping_type.$error && submitted }">
                            <option value="">Ninguno</option>
                            <option v-for="option in shippingTypes" v-bind:value="option.id" :key="option.id">
                                {{ option.description }}
                            </option>
                        </select>
                        <div v-if="!$v.card_application.shipping_type.required && submitted" class="invalid-feedback">Tipo de envío es requerido</div>
                    </div>
                    <!-- <div class="form-group col-12" v-if="card_application.shipping_type != '' && card_application.shipping_type != 'online'">
                        <label>Población de recogida</label>
                        <SelectAutocompleteField
                            :url="`/populations`"
                            :multiple="false"
                            :placeholder="'Busca una población'"
                            :label="'fullname'"
                            v-model="card_application.population"
                            :class="{ 'is-invalid': $v.card_application.population.$error && submitted }"
                        ></SelectAutocompleteField>
                        <div v-if="!$v.card_application.population.required && submitted" class="invalid-feedback">Población es requerida</div>
                    </div> -->
                    <div class="form-group col-12" v-if="card_application.shipping_type != '' && card_application.shipping_type != 'online'/* && card_application?.population?.id*/">
                        <label>Oficina de envío</label>
                        <SelectAutocompleteField
                            :url="`/card-shipping-types`"
                            :multiple="false"
                            :placeholder="'Busca una oficina'"
                            label="full_name"
                            v-model="card_application.card_shipping_type"
                            :params="{shipping_type: card_application.shipping_type/*, population_id: card_application?.population?.id*/}"
                            :class="{ 'is-invalid': $v.card_application.card_shipping_type.$error && submitted }"
                        ></SelectAutocompleteField>
                        <div v-if="!$v.card_application.card_shipping_type.required && submitted" class="invalid-feedback">Oficina de envío es requerida</div>
                    </div>
                </div>                         
            </div>
        </div>
    </Modal>
</template>